/* =====================================================
   IZY OVERHAUL -- Global JS improvements
   ===================================================== */

/* -- i18n helper: detect locale and return translated string -- */
var izyLang = (document.documentElement.lang || 'nl').split('-')[0];
var izyT = (function () {
  var t = {
    nl: {
      added_to_cart: 'Toegevoegd aan winkelwagen',
      added: 'Toegevoegd',
      not_in_stock: 'Niet op voorraad',
      not_enough_stock: 'Niet genoeg op voorraad',
      max_added: 'Maximaal aantal toegevoegd',
      max_added_msg: 'We hebben het maximale aantal toegevoegd.',
      only_x_left: 'Er zijn nog maar {n} stuks beschikbaar.',
      only_x_left_max: 'Er zijn maar {n} stuks beschikbaar. We hebben het maximum toegevoegd.',
      qty_not_available: 'Dit aantal is helaas niet beschikbaar.',
      sold_out: 'Dit product is uitverkocht.',
      not_available: 'Dit product is niet beschikbaar.',
      error: 'Er ging iets mis',
      try_again: 'Probeer het opnieuw.',
      timer_10: 'Nog 10 minuten! Je winkelmandje verloopt binnenkort.',
      timer_5: 'Nog 5 minuten! Rond je bestelling snel af.',
      timer_expired: 'Je reservering is verlopen. De producten zijn uit je winkelmandje verwijderd.',
      mix_add_design: 'Voeg IZY toe',
      mix_choose_n: 'Kies nog {n} IZY',
      mix_upgrade: 'Voeg nog een IZY toe · bespaar {pct}%',
      mix_save_hint: 'Voeg nog {n} toe → bespaar {pct}%',
      mix_save_done: 'Top! Je bespaart {pct}% op deze set',
      mix_free_hint: 'Voeg er nog 1 toe en krijg de goedkoopste gratis',
      mix_free_done: 'Top! Je goedkoopste IZY is gratis',
      cheapest_free: 'Goedkoopste gratis',
      slot_free: 'GRATIS',
      items_added: '{n} producten toegevoegd',
      per_unit: 'per IZY',
      total: 'Totaal',
      submitting: 'Even geduld...',
      modal_title: 'Stel je set samen — 3 halen, 2 betalen',
      mix_open: 'Stel je set samen',
      most_chosen: 'Meest gekozen',
      pool_match: 'Of match je {design}',
    },
    en: {
      added_to_cart: 'Added to cart',
      added: 'Added',
      not_in_stock: 'Out of stock',
      not_enough_stock: 'Not enough in stock',
      max_added: 'Maximum quantity added',
      max_added_msg: 'We have added the maximum available quantity.',
      only_x_left: 'Only {n} items left in stock.',
      only_x_left_max: 'Only {n} items available. We have added the maximum.',
      qty_not_available: 'This quantity is not available.',
      sold_out: 'This product is sold out.',
      not_available: 'This product is not available.',
      error: 'Something went wrong',
      try_again: 'Please try again.',
      timer_10: '10 minutes left! Your cart will expire soon.',
      timer_5: '5 minutes left! Complete your order soon.',
      timer_expired: 'Your reservation has expired. Products have been removed from your cart.',
      mix_add_design: 'Add IZY',
      mix_choose_n: 'Choose {n} more IZY',
      mix_upgrade: 'Add one more IZY · save {pct}%',
      mix_save_hint: 'Add {n} more → save {pct}%',
      mix_save_done: 'Nice! You save {pct}% on this set',
      mix_free_hint: 'Add 1 more and get the cheapest free',
      mix_free_done: 'Nice! Your cheapest IZY is free',
      cheapest_free: 'Cheapest free',
      slot_free: 'FREE',
      items_added: '{n} items added',
      per_unit: 'per IZY',
      total: 'Total',
      submitting: 'One moment...',
      modal_title: 'Build your set — buy 3, pay 2',
      mix_open: 'Build your set',
      most_chosen: 'Most chosen',
      pool_match: 'Or match your {design}',
    },
    de: {
      added_to_cart: 'In den Warenkorb gelegt',
      added: 'Hinzugefugt',
      not_in_stock: 'Nicht auf Lager',
      not_enough_stock: 'Nicht genug auf Lager',
      max_added: 'Maximale Menge hinzugefugt',
      max_added_msg: 'Wir haben die maximale Menge hinzugefugt.',
      only_x_left: 'Nur noch {n} Stuck verfugbar.',
      only_x_left_max: 'Nur {n} Stuck verfugbar. Wir haben das Maximum hinzugefugt.',
      qty_not_available: 'Diese Menge ist leider nicht verfugbar.',
      sold_out: 'Dieses Produkt ist ausverkauft.',
      not_available: 'Dieses Produkt ist nicht verfugbar.',
      error: 'Etwas ist schief gelaufen',
      try_again: 'Bitte versuchen Sie es erneut.',
      timer_10: 'Noch 10 Minuten! Ihr Warenkorb lauft bald ab.',
      timer_5: 'Noch 5 Minuten! Schliessen Sie Ihre Bestellung schnell ab.',
      timer_expired: 'Ihre Reservierung ist abgelaufen. Die Produkte wurden aus Ihrem Warenkorb entfernt.',
      mix_add_design: 'IZY hinzufugen',
      mix_choose_n: 'Noch {n} IZY wahlen',
      mix_upgrade: 'Noch ein IZY hinzufugen · spare {pct}%',
      mix_save_hint: 'Noch {n} dazu → spare {pct}%',
      mix_save_done: 'Super! Du sparst {pct}% bei diesem Set',
      mix_free_hint: 'Noch 1 dazu und das gunstigste ist gratis',
      mix_free_done: 'Super! Dein gunstigstes IZY ist gratis',
      cheapest_free: 'Gunstigstes gratis',
      slot_free: 'GRATIS',
      items_added: '{n} Artikel hinzugefugt',
      per_unit: 'pro IZY',
      total: 'Gesamt',
      submitting: 'Einen Moment...',
      modal_title: 'Stelle dein Set zusammen — 3 fur 2',
      mix_open: 'Set zusammenstellen',
      most_chosen: 'Am beliebtesten',
      pool_match: 'Oder kombiniere dein {design}',
    },
    fr: {
      added_to_cart: 'Ajouté au panier',
      added: 'Ajouté',
      not_in_stock: 'En rupture de stock',
      not_enough_stock: 'Stock insuffisant',
      max_added: 'Quantité maximale ajoutée',
      max_added_msg: 'Nous avons ajouté la quantité maximale disponible.',
      only_x_left: 'Plus que {n} pièces en stock.',
      only_x_left_max: 'Seulement {n} pièces disponibles. Nous avons ajouté le maximum.',
      qty_not_available: 'Cette quantité n\'est pas disponible.',
      sold_out: 'Ce produit est épuisé.',
      not_available: 'Ce produit n\'est pas disponible.',
      error: 'Une erreur s\'est produite',
      try_again: 'Veuillez réessayer.',
      timer_10: 'Plus que 10 minutes ! Votre panier va bientôt expirer.',
      timer_5: 'Plus que 5 minutes ! Finalisez votre commande rapidement.',
      timer_expired: 'Votre réservation a expiré. Les produits ont été retirés de votre panier.',
      mix_add_design: 'Ajouter un IZY',
      mix_choose_n: 'Choisissez encore {n} IZY',
      mix_upgrade: 'Ajoutez un IZY · economisez {pct}%',
      mix_save_hint: 'Encore {n} → économisez {pct}%',
      mix_save_done: 'Parfait ! Vous économisez {pct}% sur ce set',
      mix_free_hint: 'Ajoutez-en 1 et le moins cher est offert',
      mix_free_done: 'Parfait ! Votre IZY le moins cher est offert',
      cheapest_free: 'Le moins cher offert',
      slot_free: 'OFFERT',
      items_added: '{n} articles ajoutés',
      per_unit: 'par IZY',
      total: 'Au total',
      submitting: 'Un instant...',
      modal_title: 'Composez votre set — 3 pour 2',
      mix_open: 'Composez votre set',
      most_chosen: 'Le plus choisi',
      pool_match: 'Ou associez votre {design}',
    },
    es: {
      added_to_cart: 'Añadido al carrito', added: 'Añadido', not_in_stock: 'Agotado', not_enough_stock: 'No hay suficiente stock',
      max_added: 'Cantidad máxima añadida', max_added_msg: 'Hemos añadido la cantidad máxima disponible.',
      only_x_left: 'Solo quedan {n} unidades.', only_x_left_max: 'Solo hay {n} unidades disponibles. Hemos añadido el máximo.',
      qty_not_available: 'Esta cantidad no está disponible.', sold_out: 'Este producto está agotado.', not_available: 'Este producto no está disponible.',
      error: 'Algo salió mal', try_again: 'Inténtalo de nuevo.',
      timer_10: '¡Quedan 10 minutos! Tu carrito caducará pronto.', timer_5: '¡Quedan 5 minutos! Completa tu pedido pronto.',
      timer_expired: 'Tu reserva ha caducado. Los productos se han eliminado de tu carrito.',
      mix_add_design: 'Añadir IZY', mix_choose_n: 'Elige {n} IZY más', mix_upgrade: 'Añade un IZY más · ahorra {pct}%',
      mix_save_hint: 'Añade {n} más → ahorra {pct}%', mix_save_done: '¡Genial! Ahorras {pct}% en este set',
      mix_free_hint: 'Añade 1 más y el más barato es gratis', mix_free_done: '¡Genial! Tu IZY más barato es gratis',
      cheapest_free: 'El más barato gratis', slot_free: 'GRATIS', items_added: '{n} productos añadidos', per_unit: 'por IZY', total: 'Total', submitting: 'Un momento...',
      modal_title: 'Crea tu set — 3 por 2', mix_open: 'Crea tu set', most_chosen: 'Más elegido', pool_match: 'O combina tu {design}',
    },
    it: {
      added_to_cart: 'Aggiunto al carrello', added: 'Aggiunto', not_in_stock: 'Esaurito', not_enough_stock: 'Scorte insufficienti',
      max_added: 'Quantità massima aggiunta', max_added_msg: 'Abbiamo aggiunto la quantità massima disponibile.',
      only_x_left: 'Restano solo {n} pezzi.', only_x_left_max: 'Solo {n} pezzi disponibili. Abbiamo aggiunto il massimo.',
      qty_not_available: 'Questa quantità non è disponibile.', sold_out: 'Questo prodotto è esaurito.', not_available: 'Questo prodotto non è disponibile.',
      error: 'Qualcosa è andato storto', try_again: 'Riprova.',
      timer_10: 'Ancora 10 minuti! Il tuo carrello scadrà presto.', timer_5: 'Ancora 5 minuti! Completa il tuo ordine.',
      timer_expired: 'La tua prenotazione è scaduta. I prodotti sono stati rimossi dal carrello.',
      mix_add_design: 'Aggiungi IZY', mix_choose_n: 'Scegli {n} altro IZY', mix_upgrade: 'Aggiungi un altro IZY · risparmia {pct}%',
      mix_save_hint: 'Aggiungi {n} → risparmia {pct}%', mix_save_done: 'Ottimo! Risparmi {pct}% su questo set',
      mix_free_hint: 'Aggiungine 1 e il più economico è gratis', mix_free_done: 'Ottimo! Il tuo IZY più economico è gratis',
      cheapest_free: 'Il più economico gratis', slot_free: 'GRATIS', items_added: '{n} prodotti aggiunti', per_unit: 'per IZY', total: 'Totale', submitting: 'Un momento...',
      modal_title: 'Componi il tuo set — 3 x 2', mix_open: 'Componi il tuo set', most_chosen: 'Più scelto', pool_match: 'O abbina il tuo {design}',
    },
    da: {
      added_to_cart: 'Tilføjet til kurven', added: 'Tilføjet', not_in_stock: 'Ikke på lager', not_enough_stock: 'Ikke nok på lager',
      max_added: 'Maksimalt antal tilføjet', max_added_msg: 'Vi har tilføjet det maksimale antal.',
      only_x_left: 'Kun {n} stk. tilbage.', only_x_left_max: 'Kun {n} stk. tilgængelige. Vi har tilføjet det maksimale.',
      qty_not_available: 'Denne mængde er ikke tilgængelig.', sold_out: 'Dette produkt er udsolgt.', not_available: 'Dette produkt er ikke tilgængeligt.',
      error: 'Noget gik galt', try_again: 'Prøv igen.',
      timer_10: '10 minutter tilbage! Din kurv udløber snart.', timer_5: '5 minutter tilbage! Afslut din ordre hurtigt.',
      timer_expired: 'Din reservation er udløbet. Produkterne er fjernet fra din kurv.',
      mix_add_design: 'Tilføj IZY', mix_choose_n: 'Vælg {n} IZY mere', mix_upgrade: 'Tilføj en IZY mere · spar {pct}%',
      mix_save_hint: 'Tilføj {n} mere → spar {pct}%', mix_save_done: 'Super! Du sparer {pct}% på dette sæt',
      mix_free_hint: 'Tilføj 1 mere, og den billigste er gratis', mix_free_done: 'Super! Din billigste IZY er gratis',
      cheapest_free: 'Billigste gratis', slot_free: 'GRATIS', items_added: '{n} produkter tilføjet', per_unit: 'pr. IZY', total: 'I alt', submitting: 'Et øjeblik...',
      modal_title: 'Sæt dit sæt sammen — 3 for 2', mix_open: 'Sæt dit sæt sammen', most_chosen: 'Mest valgte', pool_match: 'Eller match din {design}',
    },
    ja: {
      added_to_cart: 'カートに追加しました', added: '追加しました', not_in_stock: '在庫切れ', not_enough_stock: '在庫が不足しています',
      max_added: '最大数量を追加しました', max_added_msg: '購入可能な最大数量を追加しました。',
      only_x_left: '残り{n}個です。', only_x_left_max: '残り{n}個です。最大数量を追加しました。',
      qty_not_available: 'この数量はご利用いただけません。', sold_out: 'この商品は売り切れです。', not_available: 'この商品はご利用いただけません。',
      error: 'エラーが発生しました', try_again: 'もう一度お試しください。',
      timer_10: '残り10分！カートがまもなく期限切れになります。', timer_5: '残り5分！お早めにご注文を完了してください。',
      timer_expired: '予約の有効期限が切れました。商品はカートから削除されました。',
      mix_add_design: 'IZYを追加', mix_choose_n: 'あと{n}個IZYを選択', mix_upgrade: 'IZYをもう1つ追加 · {pct}%お得',
      mix_save_hint: 'あと{n}個で{pct}%お得', mix_save_done: 'このセットで{pct}%お得！',
      mix_free_hint: 'あと1つ追加で最安値が無料', mix_free_done: '最安値のIZYが無料です！',
      cheapest_free: '最安値が無料', slot_free: '無料', items_added: '{n}個追加しました', per_unit: '1 IZYあたり', total: '合計', submitting: 'お待ちください...',
      modal_title: 'セットを作る — 3個で2個分', mix_open: 'セットを作る', most_chosen: '最も選ばれている', pool_match: 'または{design}に合わせる',
    },
    pt: {
      added_to_cart: 'Adicionado ao carrinho', added: 'Adicionado', not_in_stock: 'Esgotado', not_enough_stock: 'Quantidade insuficiente em stock',
      max_added: 'Quantidade máxima adicionada', max_added_msg: 'Adicionamos a quantidade máxima disponível.',
      only_x_left: 'Restam apenas {n} unidades.', only_x_left_max: 'Apenas {n} unidades disponíveis. Adicionamos o máximo.',
      qty_not_available: 'Esta quantidade não está disponível.', sold_out: 'Este produto está esgotado.', not_available: 'Este produto não está disponível.',
      error: 'Ocorreu um erro', try_again: 'Tente novamente.',
      timer_10: 'Faltam 10 minutos! O seu carrinho vai expirar em breve.', timer_5: 'Faltam 5 minutos! Conclua o seu pedido rapidamente.',
      timer_expired: 'A sua reserva expirou. Os produtos foram removidos do carrinho.',
      mix_add_design: 'Adicionar IZY', mix_choose_n: 'Escolha mais {n} IZY', mix_upgrade: 'Adicione mais um IZY · poupe {pct}%',
      mix_save_hint: 'Adicione mais {n} → poupe {pct}%', mix_save_done: 'Ótimo! Poupa {pct}% neste conjunto',
      mix_free_hint: 'Adicione mais 1 e o mais barato é grátis', mix_free_done: 'Ótimo! O seu IZY mais barato é grátis',
      cheapest_free: 'O mais barato grátis', slot_free: 'GRÁTIS', items_added: '{n} produtos adicionados', per_unit: 'por IZY', total: 'Total', submitting: 'Um momento...',
      modal_title: 'Monte o seu conjunto — 3 por 2', mix_open: 'Monte o seu conjunto', most_chosen: 'Mais escolhido', pool_match: 'Ou combine o seu {design}',
    }
  };
  return function (key, vars) {
    var s = (t[izyLang] || t.nl)[key] || (t.nl)[key] || key;
    if (vars) { for (var k in vars) { s = s.replace('{' + k + '}', vars[k]); } }
    return s;
  };
})();

/* -- Toast Notification -------------------------------- */

const IzyToast = {
  _container: null,

  _getContainer() {
    if (!this._container) {
      this._container = document.createElement('div');
      this._container.id = 'izy-toast-container';
      document.body.appendChild(this._container);
    }
    return this._container;
  },

  show({ title, message, type = 'success', duration = 3800 }) {
    const container = this._getContainer();

    const toast = document.createElement('div');
    toast.className = 'izy-toast izy-toast--' + type;

    const icon = type === 'success'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

    toast.innerHTML =
      '<div class="izy-toast__icon">' + icon + '</div>' +
      '<div class="izy-toast__body">' +
        '<div class="izy-toast__title">' + title + '</div>' +
        (message ? '<div class="izy-toast__message">' + message + '</div>' : '') +
      '</div>' +
      '<button class="izy-toast__close" aria-label="Sluiten">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="izy-toast__progress"></div>';

    container.appendChild(toast);

    // Trigger enter animation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => toast.classList.add('izy-toast--visible'));
    });

    // Progress bar animation
    const progress = toast.querySelector('.izy-toast__progress');
    progress.style.transitionDuration = duration + 'ms';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => progress.classList.add('izy-toast__progress--running'));
    });

    // Close button
    toast.querySelector('.izy-toast__close').addEventListener('click', () => dismiss(toast));

    // Auto-dismiss
    const timer = setTimeout(() => dismiss(toast), duration);

    function dismiss(el) {
      clearTimeout(timer);
      el.classList.remove('izy-toast--visible');
      el.classList.add('izy-toast--leaving');
      el.addEventListener('transitionend', () => el.remove(), { once: true });
    }
  }
};

/* -- Cart badge pulse ---------------------------------- */

function pulseBadge() {
  const badge = document.querySelector('.cart-link__count');
  if (!badge) return;
  badge.classList.remove('izy-badge-pulse');
  void badge.offsetWidth; // reflow to restart animation
  badge.classList.add('izy-badge-pulse');
  badge.addEventListener('animationend', () => badge.classList.remove('izy-badge-pulse'), { once: true });
}

/* -- Lock body scroll when cart drawer opens/closes -- */

(function () {
  var scrollY = 0;
  var isLocked = false;

  function lock() {
    if (isLocked) return;
    isLocked = true;
    scrollY = window.scrollY;
    document.body.style.top = '-' + scrollY + 'px';
    document.documentElement.classList.add('izy-drawer-open');
  }

  function unlock() {
    if (!isLocked) return;
    isLocked = false;
    document.documentElement.classList.remove('izy-drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  setInterval(function () {
    var drawer = document.querySelector('.js-cart-drawer');
    var isOpen = drawer && drawer.hasAttribute('open');
    if (isOpen && !isLocked) lock();
    if (!isOpen && isLocked) unlock();
  }, 200);

  // Forward scroll events to cart drawer content when drawer is open
  document.addEventListener('wheel', function (e) {
    if (!isLocked) return;
    var cartScroll = document.querySelector('.cart-drawer__content-upper');
    if (!cartScroll) return;
    if (e.target.closest('.cart-drawer')) return;
    cartScroll.scrollTop += e.deltaY;
  }, { passive: true });
})();

/* -- "Bekijk winkelmandje" badge after ATC -- */

var IzyCartBadge = (function () {
  var badge = null;
  var hideTimer = null;

  function show() {
    if (!badge) {
      badge = document.createElement('a');
      badge.className = 'izy-cart-badge';
      badge.textContent = 'Bekijk winkelmandje';
      badge.href = '/cart';
      badge.addEventListener('click', function (e) {
        e.preventDefault();
        var drawer = document.querySelector('.js-cart-drawer');
        if (drawer && drawer.open) {
          drawer.open();
          document.documentElement.classList.add('izy-drawer-open');
        } else {
          window.location.href = '/cart';
        }
        hide();
      });
      document.body.appendChild(badge);
    }

    clearTimeout(hideTimer);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        badge.classList.add('izy-cart-badge--visible');
      });
    });
    hideTimer = setTimeout(hide, 5000);
  }

  function hide() {
    if (badge) badge.classList.remove('izy-cart-badge--visible');
  }

  /* No auto-show: the cart drawer opening is the confirmation now (badge disabled). */
  return { show: show };
})();

/* -- Cart Timer: 15-minute reservation countdown -- */
/* Fully JS-driven: injects its own HTML into #izy-cart-timer-slot.
   Survives cart-form AJAX refreshes by re-injecting when needed. */

(function () {
  return; /* IZY: cart reservation timer disabled on request */
  var DURATION = 15 * 60;
  var STORAGE_KEY = 'izy_cart_timer_start';
  var ALERT_KEY = 'izy_cart_timer_alerts';
  var timerStart = null;
  var alertsShown = {};

  function buildTimerHTML() {
    var rem = getRemaining();
    var time = rem > 0 ? formatTime(rem) : '0:00';
    var scale = rem > 0 ? (rem / DURATION) : 0;
    return '<div class="izy-cart-timer" id="izy-cart-timer">'
      + '<div class="izy-cart-timer__inner">'
      + '<svg class="izy-cart-timer__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
      + '<span class="izy-cart-timer__text">Je winkelmandje is <strong id="izy-timer-countdown">' + time + '</strong> gereserveerd</span>'
      + '</div>'
      + '<div class="izy-cart-timer__bar"><div class="izy-cart-timer__bar-fill" id="izy-timer-bar" style="transform:scaleX(' + scale + ')"></div></div>'
      + '</div>';
  }

  function loadAlerts() {
    try { var s = sessionStorage.getItem(ALERT_KEY); if (s) alertsShown = JSON.parse(s); } catch (e) {}
  }
  function saveAlerts() {
    try { sessionStorage.setItem(ALERT_KEY, JSON.stringify(alertsShown)); } catch (e) {}
  }

  function hasTimerStarted() {
    try { return !!sessionStorage.getItem(STORAGE_KEY); } catch (e) { return !!timerStart; }
  }

  function getRemaining() {
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) timerStart = parseInt(stored, 10);
    } catch (e) {}
    if (!timerStart) return -1; /* Timer not started */
    return Math.max(0, DURATION - (Math.floor(Date.now() / 1000) - timerStart));
  }

  function formatTime(s) {
    return Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60);
  }

  function showTimerPopup(msg) {
    var popup = document.createElement('div');
    popup.className = 'izy-timer-popup';
    popup.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> ' + msg;
    document.body.appendChild(popup);
    setTimeout(function () { popup.classList.add('izy-timer-popup--visible'); }, 10);
    setTimeout(function () {
      popup.classList.remove('izy-timer-popup--visible');
      setTimeout(function () { popup.remove(); }, 400);
    }, 6000);
  }

  function removeExpiredItems() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items || cart.items.length === 0) return;
      var updates = {};
      var hasRegular = false;
      cart.items.forEach(function (item) {
        var isNpl = (item.handle && item.handle.indexOf('postcode-loterij') !== -1);
        if (!isNpl) { updates[item.key] = 0; hasRegular = true; }
      });
      if (!hasRegular) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        showTimerPopup(izyT('timer_expired'));
        document.dispatchEvent(new CustomEvent('on:cart:update'));
        timerStart = null;
        try { sessionStorage.removeItem(STORAGE_KEY); sessionStorage.removeItem(ALERT_KEY); } catch (e) {}
        alertsShown = {};
        /* Remove timer UI */
        var el = document.getElementById('izy-cart-timer');
        if (el) el.remove();
      });
    });
  }

  /* Ensure timer HTML exists in the slot */
  function ensureTimerDOM() {
    if (document.getElementById('izy-cart-timer')) return true;
    var slot = document.getElementById('izy-cart-timer-slot');
    if (!slot) return false;
    slot.innerHTML = buildTimerHTML();
    return true;
  }

  function update() {
    var slot = document.getElementById('izy-cart-timer-slot');
    if (!hasTimerStarted()) {
      /* Hide slot when no timer */
      if (slot) slot.style.display = 'none';
      return;
    }
    if (slot) slot.style.display = '';
    var remaining = getRemaining();
    if (remaining < 0) return;

    /* Only inject/update when timer elements are visible (drawer open) */
    if (!ensureTimerDOM()) return;

    var countdown = document.getElementById('izy-timer-countdown');
    var bar = document.getElementById('izy-timer-bar');
    var container = document.getElementById('izy-cart-timer');
    if (!countdown || !bar || !container) return;

    countdown.textContent = formatTime(remaining);
    bar.style.transform = 'scaleX(' + (remaining / DURATION) + ')';

    if (remaining <= 300) container.classList.add('izy-cart-timer--warning');
    else container.classList.remove('izy-cart-timer--warning');

    /* Popup at 10 minutes */
    if (remaining <= 600 && remaining > 595 && !alertsShown['10m']) {
      alertsShown['10m'] = true; saveAlerts();
      showTimerPopup(izyT('timer_10'));
    }
    /* Popup at 5 minutes */
    if (remaining <= 300 && remaining > 295 && !alertsShown['5m']) {
      alertsShown['5m'] = true; saveAlerts();
      showTimerPopup(izyT('timer_5'));
    }
    /* Expired */
    if (remaining <= 0) {
      container.classList.add('izy-cart-timer--expired');
      if (!alertsShown['expired']) {
        alertsShown['expired'] = true; saveAlerts();
        removeExpiredItems();
      }
    }
  }

  loadAlerts();
  setInterval(update, 1000);

  /* Start/reset timer on add to cart (skip NPL pages) */
  function resetTimer() {
    if (document.querySelector('.izy-npl-form')) return;
    timerStart = Math.floor(Date.now() / 1000);
    try { sessionStorage.setItem(STORAGE_KEY, String(timerStart)); } catch (e) {}
    alertsShown = {};
    try { sessionStorage.setItem(ALERT_KEY, '{}'); } catch (e) {}
    /* Immediately inject timer if slot exists */
    ensureTimerDOM();
    update();
  }
  document.addEventListener('on:cart:add', resetTimer);

  /* When drawer opens, re-inject timer if it was removed by cart refresh */
  document.addEventListener('theme:open-cart-drawer', function () {
    setTimeout(function () { ensureTimerDOM(); update(); }, 300);
  });
  /* Also catch cart-form refreshes */
  var observer = new MutationObserver(function () {
    if (hasTimerStarted() && !document.getElementById('izy-cart-timer')) {
      ensureTimerDOM();
      update();
    }
  });
  var cartDrawer = document.querySelector('cart-form');
  if (cartDrawer) observer.observe(cartDrawer, { childList: true, subtree: true });
})();

/* -- Collection slider: infinite loop (wrapAround) but LEFT-aligned and starting on slide 0,
   so the first slide (Travel Bottles) sits flush left at rest — the last slide (Tumblers) no
   longer peeks on the left — while the loop still fills the right edge (no white gap). -- */

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelectorAll('.custom_collection_slider_carousel').forEach(function (el) {
      var flkty = Flickity.data(el);
      if (flkty) {
        flkty.options.wrapAround = true;
        flkty.destroy();
        var newFlkty = new Flickity(el, {
          cellAlign: 'left',
          prevNextButtons: false,
          pageDots: true,
          initialIndex: 0,
          wrapAround: true
        });
        // Re-append dots to action wrapper
        var pageDots = el.querySelector('.flickity-page-dots');
        var actionWrapper = el.closest('.custom-collection-slider-container');
        var wrapper = actionWrapper ? actionWrapper.querySelector('.flickity-action-wrapper') : null;
        if (pageDots && wrapper) wrapper.appendChild(pageDots);
        // Re-bind prev/next buttons
        var prev = actionWrapper ? actionWrapper.querySelector('.custom-prev') : null;
        var next = actionWrapper ? actionWrapper.querySelector('.custom-next') : null;
        if (prev) prev.addEventListener('click', function () { newFlkty.previous(true); });
        if (next) next.addEventListener('click', function () { newFlkty.next(true); });
      }
    });
  }, 500);
});

/* -- Fix: Stop carousels from hijacking vertical scroll -- */

(function () {
  // Block wheel events from reaching sliders entirely on desktop
  if (!window.matchMedia('(pointer: fine)').matches) return;

  document.addEventListener('wheel', function (e) {
    var slider = e.target.closest('.slider');
    if (!slider) return;

    // Only block if user is scrolling vertically
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;

    // Prevent the slider from receiving this scroll
    e.preventDefault();

    // Scroll the page instead
    window.scrollBy({ top: e.deltaY, behavior: 'instant' });
  }, { passive: false, capture: true });
})();

/* -- Quantity stepper on product card ATC -- */

function injectSteppers() {
  document.querySelectorAll('.prod_thumb_atc_button').forEach(function (wrapper) {
    if (wrapper.querySelector('.izy-qty-stepper')) return;
    var atcBtn = wrapper.querySelector('button');
    if (!atcBtn) return;

    var stepper = document.createElement('div');
    stepper.className = 'izy-qty-stepper';
    stepper.innerHTML =
      '<span class="izy-qty-btn izy-qty-minus" role="button" tabindex="0">-</span>' +
      '<input type="number" class="izy-qty-val" value="1" min="1" max="99">' +
      '<span class="izy-qty-btn izy-qty-plus" role="button" tabindex="0">+</span>';
    wrapper.insertBefore(stepper, atcBtn);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  injectSteppers();
  // Re-inject after AJAX section loads
  document.addEventListener('shopify:section:load', injectSteppers);
  // Also retry after a short delay for lazy-loaded carousels
  setTimeout(injectSteppers, 1500);
  setTimeout(injectSteppers, 3000);

  // Handle +/- via mousedown
  document.addEventListener('mousedown', function (e) {
    var isMinus = e.target.classList.contains('izy-qty-minus');
    var isPlus = e.target.classList.contains('izy-qty-plus');
    if (!isMinus && !isPlus) return;

    e.preventDefault();
    var input = e.target.parentElement.querySelector('.izy-qty-val');
    var val = parseInt(input.value, 10) || 1;

    if (isMinus && val > 1) input.value = val - 1;
    if (isPlus && val < 99) input.value = val + 1;
  });

  // Sanitize typed input
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('izy-qty-val')) return;
    var val = parseInt(e.target.value, 10);
    if (!val || val < 1) e.target.value = 1;
    if (val > 99) e.target.value = 99;
  });

  // Select all on focus for easy typing
  document.addEventListener('focus', function (e) {
    if (e.target.classList.contains('izy-qty-val')) e.target.select();
  }, true);
});

/* -- Global Add-to-Cart handler ------------------------ */

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    // Ignore clicks on stepper buttons
    if (e.target.classList.contains('izy-qty-btn')) return;

    var btn = e.target.closest('.prod_thumb_atc_button button');
    if (!btn) return;

    var variantId = btn.getAttribute('data-id');
    if (!variantId) return;

    var wrapper = btn.closest('.prod_thumb_atc_button');
    var qtyInput = wrapper ? wrapper.querySelector('.izy-qty-val') : null;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var btnText   = btn.querySelector('.btn-text');
    var btnLoader = btn.querySelector('.btn-loader');

    if (btnText)   btnText.style.display   = 'none';
    if (btnLoader) btnLoader.style.display = 'block';

    // Disable button during request
    btn.disabled = true;

    /* Open the cart drawer immediately so opening never depends on network timing. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); }
    } else if (drawer) {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ quantity: quantity, id: parseInt(variantId, 10), sections: ['cart-drawer'], sections_url: '/' })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          // Out of stock (422) or other error
          var errMsg = result.data.description || result.data.message || izyT('not_available');
          // Map common Shopify English errors to Dutch
          if (/all .* on-hand quantities/i.test(errMsg) || /sold out/i.test(errMsg) || result.status === 422) {
            errMsg = izyT('sold_out');
          }
          IzyToast.show({ title: izyT('not_in_stock'), message: errMsg, type: 'error', duration: 4500 });
          return;
        }

        /* Fill the already-open drawer with the freshly rendered cart contents. */
        try {
          if (result.data && result.data.sections && result.data.sections['cart-drawer'] && drawer && typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(result.data.sections['cart-drawer']);
          } else {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          }
        } catch (e) { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); }
        /* Safety: re-open if the content swap collapsed it. */
        try { if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) drawer.open(); } catch (e) {}

        var cartForm = document.querySelector('cart-form');
        if (cartForm && cartForm.refresh) { cartForm.refresh(); }
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[IZY ATC] Failed to add item:', err);
        IzyToast.show({ title: izyT('error'), message: izyT('try_again'), type: 'error' });
      })
      .finally(function () {
        if (btnLoader) btnLoader.style.display = 'none';
        if (btnText)   btnText.style.display   = '';
        btn.disabled = false;
      });
  });
});

/* -- IZY Buybox: Mix & Match selector --
   Tier 1 = this design at full price. Tier 2/3 = add other designs of the same
   family+format; Shopify's cart-wide automatic discounts (2 items = 10%, 3+ = 20%)
   apply at checkout. Slot 0 is always the current product (locked). */

var IzyMix = (function () {
  var S = {
    tier: 1, discount: 0, basePrice: 0, fsThreshold: 0,
    candidates: [], pool1: [], pool2: [],
    thisFormat: '', thisDesign: '',
    slots: [], atcLabel: '', modalOpen: false
  };

  function wrap() { return document.querySelector('.izy-bb__mixwrap'); }
  function money(c) { return (typeof izyFormatPrice === 'function') ? izyFormatPrice(c) : ('€' + (c / 100).toFixed(2)); }
  /* Per-product square background matching the rest of the site: a metafield colour or the
     product photo's 1px average colour, fading to white at the bottom (like the collection cards). */
  function slotBg(bg) {
    if (!bg) return '';
    var v = ('' + bg).trim();
    if (v.charAt(0) === '#' || v.indexOf('rgb') === 0)
      return 'linear-gradient(180deg, ' + v + ' 0%, ' + v + ' 32%, #ffffff 96%)';
    return 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 32%, #ffffff 96%), url("' + v + '") center/cover';
  }
  function maxTier() { return Math.min(3, 1 + (S.pool1.length + S.pool2.length)); }
  function discountForCount(n) { return n >= 3 ? 20 : (n === 2 ? 10 : 0); }
  /* Net total for a set of item prices: 3+ = cheapest free ("3 halen 2 betalen"), 2 = 10% off, 1 = full. */
  function netForPrices(prices) {
    var count = prices.length, gross = 0, min = Infinity, i;
    for (i = 0; i < count; i++) { gross += prices[i]; if (prices[i] < min) min = prices[i]; }
    if (count >= 3) return gross - min;             /* the cheapest item is free */
    if (count === 2) return Math.round(gross * 0.9); /* 10% off */
    return gross;                                    /* full price */
  }
  /* Keep the PDP tier cards in step with the set the shopper is actually building: the card
     matching the current design count becomes active (so it lights up + shows all its slots). */
  function syncTierToCount() {
    var w = wrap(); if (!w) return;
    var n = Math.min(3, Math.max(1, filledCount()));
    S.tier = n;
    S.discount = discountForCount(n);
    w.querySelectorAll('.izy-bb__tier').forEach(function (t) {
      var tn = parseInt(t.getAttribute('data-tier'), 10) || 1;
      t.classList.toggle('is-active', tn === n);
    });
  }
  function poolItem(id) { return S.pool1.concat(S.pool2).filter(function (c) { return c.id === id; })[0]; }
  function usedIds() { return S.slots.filter(Boolean).map(function (s) { return s.id; }); }
  function filledCount() { return S.slots.filter(Boolean).length; }

  function init() {
    var w = wrap();
    if (!w) return;
    S.basePrice = parseInt(w.getAttribute('data-base-price'), 10) || 0;
    S.fsThreshold = parseInt(w.getAttribute('data-fs-threshold'), 10) || 0;
    try { S.candidates = JSON.parse(w.querySelector('.izy-mix-data').textContent) || []; }
    catch (e) { S.candidates = []; }
    S.thisFormat = w.getAttribute('data-this-format') || '';
    S.thisDesign = w.getAttribute('data-this-design') || '';
    /* Pool 1 = same bottle, other art (mix the designs). Pool 2 = same design, other models.
       Dedupe by design+format so a design that exists as two products (e.g. the same art in
       two overlapping collections) only appears once. */
    function dedupeByDesign(list) {
      var seen = {}, out = [];
      list.forEach(function (c) {
        var k = (c.design || '') + '|' + (c.format || '');
        if (!seen[k]) { seen[k] = 1; out.push(c); }
      });
      return out;
    }
    S.pool1 = dedupeByDesign(S.candidates.filter(function (c) { return c.format === S.thisFormat && c.design !== S.thisDesign; }));
    S.pool2 = dedupeByDesign(S.candidates.filter(function (c) { return c.design === S.thisDesign && c.format !== S.thisFormat; }));
    var lblEl = document.querySelector('[data-izy-atc-label]');
    S.atcLabel = (lblEl && lblEl.textContent.trim()) || izyT('added_to_cart');
    S.tier = 1; S.discount = 0;
    S.slots = [{
      id: parseInt(w.getAttribute('data-this-id'), 10),
      name: w.getAttribute('data-this-name') || S.thisDesign || '',
      img: w.getAttribute('data-this-img') || '',
      bg: w.getAttribute('data-this-bg') || '',
      price: S.basePrice, locked: true
    }];
    /* Make the design you're viewing re-pickable too, so you can order it 2×/3× (same product). */
    if (S.pool1 && S.slots[0] && S.slots[0].id) {
      S.pool1.unshift({ id: S.slots[0].id, design: S.slots[0].name, format: S.thisFormat, price: S.basePrice, img: S.slots[0].img, bg: S.slots[0].bg, isBase: true });
    }
    var mt = maxTier();
    w.querySelectorAll('.izy-bb__tier').forEach(function (t) {
      var tn = parseInt(t.getAttribute('data-tier'), 10) || 1;
      t.classList.toggle('is-disabled', tn > mt);
      t.classList.toggle('is-active', tn === 1);
    });
    renderTierPrices();
    renderTierSlots();
    updatePageAtc();
  }

  function setTier(n) {
    var w = wrap(); if (!w) return;
    var card = w.querySelector('.izy-bb__tier[data-tier="' + n + '"]');
    if (!card || card.classList.contains('is-disabled')) return;
    S.tier = n;
    S.discount = parseInt(card.getAttribute('data-discount'), 10) || 0;
    w.querySelectorAll('.izy-bb__tier').forEach(function (t) { t.classList.remove('is-active'); });
    card.classList.add('is-active');
    if (n <= 1) {
      /* Single: keep only the base design and close the builder. */
      S.slots = [S.slots[0]];
    } else {
      /* 2/3 Designs: open the flexible builder — keep only real picks (drop empty slots);
         the builder then grows one slot at a time as designs are added. */
      S.slots = S.slots.filter(Boolean);
    }
    renderTierPrices();
    renderTierSlots();
    /* Selecting 2/3 Designs opens the customize menu straight away. */
    if (n > 1) { openModal(); } else { closeModal(); }
    updatePageAtc();
  }

  function pick(id) {
    /* Same design allowed more than once (2×/3× the same product) — no "already picked" block. */
    var c = poolItem(id); if (!c) return;
    if (filledCount() >= Math.min(3, maxTier())) return; /* set already at its max size */
    S.slots.push({ id: c.id, name: c.design, img: c.img, price: c.price, bg: c.bg });
    syncTierToCount(); /* move the PDP selection to the matching tier card */
    renderModal(); /* stay open so the shopper can add another design / review */
  }

  function clearSlot(i) { if (i > 0 && S.slots[i]) { S.slots.splice(i, 1); syncTierToCount(); renderModal(); } }

  function getItems() {
    var map = {};
    S.slots.filter(Boolean).forEach(function (s) { map[s.id] = (map[s.id] || 0) + 1; });
    var tagged = filledCount() > 1;
    return Object.keys(map).map(function (id) {
      var item = { id: parseInt(id, 10), quantity: map[id] };
      if (tagged) item.properties = { _mix: '1' };
      return item;
    });
  }

  function renderTierPrices() {
    var w = wrap(); if (!w) return;
    w.querySelectorAll('.izy-bb__tier').forEach(function (t) {
      var tn = parseInt(t.getAttribute('data-tier'), 10) || 1;
      var estPrices = []; for (var pi = 0; pi < tn; pi++) estPrices.push(S.basePrice);
      var net = netForPrices(estPrices);
      var wasEl = t.querySelector('.izy-bb__price-was');
      var nowEl = t.querySelector('.izy-bb__price-now');
      var perEl = t.querySelector('[data-izy-per]');
      /* Per-unit pricing: struck old per-unit on top, new per-unit in green, total below. */
      if (wasEl && tn > 1) wasEl.textContent = money(S.basePrice);
      if (nowEl) nowEl.textContent = money(Math.round(net / tn));
      if (perEl && tn > 1) perEl.textContent = izyT('total') + ' ' + money(net);
    });
    updateShippingLabels();
  }

  /* Inline slots inside each tier card: slot 0 = the current product; the rest are the
     chosen designs (active tier) or empty "+" placeholders. Clicking a "+" opens the picker. */
  function renderTierSlots() {
    var w = wrap(); if (!w) return;
    w.querySelectorAll('.izy-bb__tier').forEach(function (t) {
      var holder = t.querySelector('[data-izy-tslots]');
      if (!holder) return;
      var tn = parseInt(t.getAttribute('data-tier'), 10) || 1;
      var isActive = t.classList.contains('is-active');
      holder.innerHTML = '';
      for (var i = 0; i < tn; i++) {
        var slot = (i === 0) ? S.slots[0] : (isActive ? S.slots[i] : null);
        var div = document.createElement('div');
        div.className = 'izy-bb__tslot' + (slot ? ' is-filled' : ' is-empty');
        if (slot) {
          div.innerHTML = '<img class="izy-bb__tslot-img" src="' + (slot.img || '') + '" alt="">';
        } else {
          div.innerHTML = '<span class="izy-bb__tslot-plus">+</span>';
          div.setAttribute('data-izy-tslot', i);
        }
        holder.appendChild(div);
      }
    });
  }

  /* Show the "GRATIS VERZENDING" tag on a tier only when that tier's total actually reaches
     the visitor's country free-shipping threshold — otherwise it would over-promise (e.g. a
     2-pack of cheap lids that never clears €40). Uses the discounted total (what the cart
     charges), and the active tier's real configured total once it's complete. */
  function updateShippingLabels() {
    var w = wrap(); if (!w) return;
    w.querySelectorAll('.izy-bb__tier').forEach(function (t) {
      var ship = t.querySelector('[data-izy-ship]');
      if (!ship) return;
      var tn = parseInt(t.getAttribute('data-tier'), 10) || 1;
      var disc = parseInt(t.getAttribute('data-discount'), 10) || 0;
      var total = (tn === S.tier && filledCount() === S.tier)
        ? realNet().net
        : Math.round(S.basePrice * tn * (100 - disc) / 100);
      ship.hidden = !(S.fsThreshold > 0 && total >= S.fsThreshold);
    });
  }

  /* ---- Modal ---- */
  function modalEl() { return document.querySelector('[data-izy-modal]'); }
  function openModal() {
    var m = modalEl(); if (!m) return;
    /* Portal the modal to <body> so it escapes any transformed ancestor. The product
       column's reveal animation (data-cc-animate) leaves a transform on an ancestor,
       which otherwise captures position:fixed and makes the sheet drift/hide with scroll. */
    if (m.parentNode !== document.body) document.body.appendChild(m);
    /* Robust iOS scroll-lock (same as the cart drawer): pin the body so the background
       can't scroll/bounce behind the sheet, which is what made the footer drift out of view. */
    S.lockScrollY = window.scrollY || window.pageYOffset || 0;
    m.hidden = false; m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('izy-modal-open');
    document.body.style.top = '-' + S.lockScrollY + 'px';
    S.modalOpen = true;
    renderModal();
  }
  function closeModal() {
    var wasOpen = S.modalOpen;
    var m = modalEl(); if (m) { m.hidden = true; m.setAttribute('aria-hidden', 'true'); }
    document.documentElement.classList.remove('izy-modal-open');
    document.body.style.top = '';
    if (wasOpen) window.scrollTo(0, S.lockScrollY || 0);
    S.modalOpen = false;
  }

  function renderModal() {
    var w = modalEl(); if (!w) return;
    var titleEl = w.querySelector('[data-izy-modal-title]');
    if (titleEl) titleEl.textContent = izyT('modal_title');

    /* Slots — filled designs first, then one trailing empty "+" slot until the set is full. */
    var slotsEl = w.querySelector('[data-izy-slots]');
    if (slotsEl) {
      slotsEl.innerHTML = '';
      var slotCap = Math.min(3, maxTier());
      var filledSlots = S.slots.filter(Boolean);
      /* Once the set hits 3, mark the cheapest design as the free one — a big green
         "GRATIS" ribbon right on that slot makes the deal impossible to miss. */
      var freeIdx = -1;
      if (filledSlots.length >= 3) {
        var mn = Infinity;
        filledSlots.forEach(function (s, i) { if (s.price < mn) { mn = s.price; freeIdx = i; } });
      }
      filledSlots.forEach(function (slot, i) {
        var isFree = (i === freeIdx);
        var div = document.createElement('div');
        div.className = 'izy-bb__slot is-filled' + (slot.locked ? ' is-locked' : '') + (isFree ? ' is-free' : '');
        if (slot.bg) div.style.setProperty('--slot-bg', slotBg(slot.bg));
        div.innerHTML =
          (isFree ? '<span class="izy-bb__slot-free">' + izyEsc(izyT('slot_free')) + '</span>' : '') +
          '<img class="izy-bb__slot-img" src="' + (slot.img || '') + '" alt="" loading="lazy">' +
          '<span class="izy-bb__slot-name">' + izyEsc(slot.name) + '</span>' +
          (slot.locked ? '' : '<button type="button" class="izy-bb__slot-x" data-izy-clear="' + i + '" aria-label="x">&times;</button>');
        slotsEl.appendChild(div);
      });
      /* Progressive disclosure: always show one more empty "+" slot until the set is full,
         so it stays obvious you can keep adding designs (2nd added → 3rd slot appears). */
      if (filledCount() < slotCap) {
        var nextCount = filledCount() + 1;
        var ediv = document.createElement('div');
        ediv.className = 'izy-bb__slot is-empty';
        /* Only show a % badge for the 2nd design. The 3rd (free) isn't earned yet, so we
           don't put a "gratis" claim on the empty slot — the reward banner explains it. */
        var disc = (nextCount >= 3)
          ? ''
          : (discountForCount(nextCount) > 0 ? '<span class="izy-bb__slot-disc">-' + discountForCount(nextCount) + '%</span>' : '');
        ediv.innerHTML = '<span class="izy-bb__slot-plus">+</span><span class="izy-bb__slot-name">' + izyEsc(izyT('mix_add_design')) + '</span>' + disc;
        slotsEl.appendChild(ediv);
      }
    }

    /* The always-visible trailing "+" slot replaces the old upgrade button. */
    var upEl = w.querySelector('[data-izy-modal-upgrade]');
    if (upEl) { upEl.innerHTML = ''; upEl.hidden = true; }

    renderPool(w.querySelector('[data-izy-pool1]'), w.querySelector('[data-izy-pool1-track]'), S.pool1, true);
    var p2label = w.querySelector('[data-izy-pool2-label]');
    if (p2label) p2label.textContent = izyT('pool_match', { design: S.thisDesign });
    renderPool(w.querySelector('[data-izy-pool2]'), w.querySelector('[data-izy-pool2-track]'), S.pool2, false);

    renderFoot();
    renderReward();
    renderTierSlots(); /* keep the inline tier-card slots in sync while picking */
  }

  /* Reward banner — makes the saving explicit as the shopper fills slots. At 3 designs
     the cheapest is free ("goedkoopste gratis"); at 2 it's the 10% mix discount. */
  function renderReward() {
    var w = modalEl(); if (!w) return;
    var el = w.querySelector('[data-izy-reward]');
    if (!el) return;
    var count = filledCount();
    var cap = Math.min(3, maxTier());
    var curDisc = discountForCount(count);
    if (count >= cap) {
      /* Maxed out: confirm what was earned — free cheapest at 3, else the % saving. */
      if (count >= 3) {
        el.hidden = false; el.classList.add('is-done');
        el.innerHTML = '<span class="izy-bb__reward-txt izy-bb__reward-txt--full">' + izyEsc(izyT('mix_free_done')) + '</span>';
      } else if (curDisc > 0) {
        el.hidden = false; el.classList.add('is-done');
        el.innerHTML = '<span class="izy-bb__reward-txt izy-bb__reward-txt--full">' + izyEsc(izyT('mix_save_done', { pct: curDisc })) + '</span>';
      } else { el.hidden = true; el.innerHTML = ''; el.classList.remove('is-done'); }
      return;
    }
    var nextCount = count + 1;
    el.hidden = false; el.classList.remove('is-done');
    if (nextCount >= 3) {
      /* One away from the free deal — the shopper hasn't earned it yet, so NO "gratis"
         badge; just the call-to-action sentence spanning the full banner width. */
      el.innerHTML = '<span class="izy-bb__reward-txt izy-bb__reward-txt--full">' + izyEsc(izyT('mix_free_hint')) + '</span>';
      return;
    }
    var nextDisc = discountForCount(nextCount);
    el.innerHTML = '<span class="izy-bb__reward-pct">-' + nextDisc + '%</span>' +
      '<span class="izy-bb__reward-txt">' + izyEsc(izyT('mix_save_hint', { n: 1, pct: nextDisc })) + '</span>';
  }

  function renderPool(poolWrap, track, items, isPrimary) {
    if (!poolWrap || !track) return;
    if (!items.length) { poolWrap.hidden = true; return; }
    poolWrap.hidden = false;
    track.innerHTML = '';
    /* Count how many of each design are already in the set — cards stay clickable so the
       same design can be added again; a small "×N" badge shows how many are in the set. */
    var counts = {};
    S.slots.filter(Boolean).forEach(function (s) { counts[s.id] = (counts[s.id] || 0) + 1; });
    var badgeIdx = -1;
    if (isPrimary) { for (var bi = 0; bi < items.length; bi++) { if (!items[bi].isBase) { badgeIdx = bi; break; } } }
    items.forEach(function (c, idx) {
      var inSet = counts[c.id] || 0;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'izy-bb__pick' + (inSet ? ' is-chosen' : '');
      btn.setAttribute('data-izy-pick', c.id);
      if (c.bg) btn.style.setProperty('--pick-bg', slotBg(c.bg));
      var badge = (idx === badgeIdx) ? '<span class="izy-bb__pick-badge">' + izyEsc(izyT('most_chosen')) + '</span>' : '';
      if (inSet) badge += '<span class="izy-bb__pick-count">' + inSet + '×</span>';
      /* Pool 2 cards label the model (mug/tumbler/travel); Pool 1 cards don't (all same model). */
      var sub = isPrimary ? '' : '<span class="izy-bb__pick-fmt">' + izyEsc(izyFmtLabel(c.format)) + '</span>';
      btn.innerHTML = badge +
        '<img class="izy-bb__pick-img" src="' + (c.img || '') + '" alt="" loading="lazy">' +
        '<span class="izy-bb__pick-name">' + izyEsc(c.design) + '</span>' + sub +
        '<span class="izy-bb__pick-price">' + money(c.price) + '</span>';
      track.appendChild(btn);
    });
  }

  /* The binding price for a mix = sum of the ACTUAL picked items (formats differ in
     price), discounted. This is what the cart charges, so the page must show the same. */
  function realNet() {
    var filled = S.slots.filter(Boolean);
    var prices = filled.map(function (x) { return x.price; });
    var gross = prices.reduce(function (s, p) { return s + p; }, 0);
    var count = prices.length;
    var net = netForPrices(prices);
    /* Every set size is valid to check out; at 3 the cheapest design is free. */
    return { gross: gross, count: count, net: net, saved: gross - net, cheapestFree: count >= 3, complete: true, discount: discountForCount(count) };
  }

  function renderFoot() {
    var w = modalEl(); if (!w) return;
    var r = realNet();
    var wasEl = w.querySelector('[data-izy-modal-was]');
    var nowEl = w.querySelector('[data-izy-modal-now]');
    var perEl = w.querySelector('[data-izy-modal-per]');
    var cta = w.querySelector('[data-izy-modal-add]');
    var ctaLbl = w.querySelector('[data-izy-modal-cta-label]');
    var count = r.count || 1;
    /* Same structure as the tier cards: struck old per-unit, new per-unit in green, then total. */
    if (wasEl) wasEl.textContent = (r.discount > 0) ? money(S.basePrice) : '';
    if (nowEl) nowEl.textContent = money(Math.round(r.net / count));
    if (perEl) perEl.textContent = izyT('total') + ' ' + money(r.net);
    if (cta) {
      /* Always addable — any number of designs is a valid set. */
      cta.disabled = false;
      cta.classList.remove('is-incomplete');
      if (ctaLbl) ctaLbl.textContent = S.atcLabel + '  ·  ' + money(r.net);
    }
    /* Keep the page button in sync with the real total. */
    updatePageAtc();
  }

  /* When a complete set is built, the active tier card shows the EXACT configured total
     (matches modal + cart); otherwise it falls back to the base-product estimate. */
  function syncActiveTierPrice() {
    var w = wrap(); if (!w) return;
    var card = w.querySelector('.izy-bb__tier.is-active');
    if (!card) return;
    var tn = parseInt(card.getAttribute('data-tier'), 10) || 1;
    if (tn <= 1) return;
    var r = realNet();
    var nowEl = card.querySelector('.izy-bb__price-now');
    var wasEl = card.querySelector('.izy-bb__price-was');
    var perEl = card.querySelector('[data-izy-per]');
    var gross = r.complete ? r.gross : S.basePrice * tn;
    var net = r.complete ? r.net : Math.round(gross * (100 - S.discount) / 100);
    if (wasEl) wasEl.textContent = money(Math.round(gross / tn));
    if (nowEl) nowEl.textContent = money(Math.round(net / tn));
    if (perEl) perEl.textContent = izyT('total') + ' ' + money(net);
    updateShippingLabels();
  }

  /* Page ATC: tier 1 adds the single product; tier 2/3 opens the configurator. */
  function updatePageAtc() {
    var btn = document.querySelector('.izy-bb__atc');
    if (!btn) return;
    /* Notify the sticky bar (and anything else) that the selected-design count changed. */
    try { document.dispatchEvent(new CustomEvent('izy:mix:change')); } catch (e) {}
    var priceEl = document.querySelector('[data-izy-atc-price]');
    var lbl = btn.querySelector('[data-izy-atc-label]');
    btn.disabled = false; btn.classList.remove('is-incomplete');
    if (lbl) lbl.textContent = S.atcLabel;
    if (S.tier <= 1) {
      if (priceEl) priceEl.textContent = money(S.basePrice);
      return;
    }
    /* Tier 2/3: show the tier price — the base×tier estimate until the set is complete,
       then the exact configured total (what the cart charges). Clicking an incomplete set
       opens the picker (handled in the submit handler), so it never adds a half-built set. */
    var estPrices = []; for (var ei = 0; ei < S.tier; ei++) estPrices.push(S.basePrice);
    var shown = (filledCount() > 1) ? realNet().net : netForPrices(estPrices);
    if (priceEl) priceEl.textContent = money(shown);
  }

  function setBasePrice(cents, variantId) {
    S.basePrice = cents;
    if (S.slots[0]) { S.slots[0].price = cents; if (variantId) S.slots[0].id = variantId; }
    renderTierPrices(); updatePageAtc();
    if (S.modalOpen) renderModal();
  }

  return {
    init: init, setTier: setTier, pick: pick, clearSlot: clearSlot,
    getItems: getItems, filledCount: filledCount, setBasePrice: setBasePrice,
    openModal: openModal, closeModal: closeModal,
    tierVal: function () { return S.tier; },
    isComplete: function () { return S.tier === 1 || filledCount() === S.tier; },
    state: function () { return S; }
  };
})();

function izyEsc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
    return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
  });
}

/* Map the custom.format code (Fles/Mug/Tumbler/Travel) to a localized model label for
   the Pool 2 cards. Unknown values (e.g. a title-parsed "IZY Mug") pass through as-is. */
function izyFmtLabel(code) {
  var c = String(code == null ? '' : code).trim();
  var maps = {
    nl: { 'Fles': 'Fles', 'Mug': 'Beker', 'Tumbler': 'Tumbler', 'Travel': 'Reisfles', 'Set': 'Set' },
    en: { 'Fles': 'Bottle', 'Mug': 'Mug', 'Tumbler': 'Tumbler', 'Travel': 'Travel bottle', 'Set': 'Set' },
    de: { 'Fles': 'Flasche', 'Mug': 'Becher', 'Tumbler': 'Tumbler', 'Travel': 'Reiseflasche', 'Set': 'Set' },
    fr: { 'Fles': 'Bouteille', 'Mug': 'Mug', 'Tumbler': 'Tumbler', 'Travel': 'Bouteille de voyage', 'Set': 'Set' }
  };
  var m = maps[izyLang] || maps.nl;
  return m[c] || c;
}

/* Tier card click → select tier; clicking a "+" slot opens the design picker. */
document.addEventListener('click', function (e) {
  var tier = e.target.closest('.izy-bb__tier');
  if (tier && tier.closest('.izy-bb__mixwrap')) {
    IzyMix.setTier(parseInt(tier.getAttribute('data-tier'), 10) || 1);
    return;
  }
  /* "Add another design" upsell inside the modal → bump to the next tier. */
  var upg = e.target.closest('[data-izy-upgrade]');
  if (upg) { IzyMix.setTier(Math.min(3, IzyMix.tierVal() + 1)); return; }
  /* Pool design → fill slot */
  var pick = e.target.closest('[data-izy-pick]');
  if (pick) {
    IzyMix.pick(parseInt(pick.getAttribute('data-izy-pick'), 10));
    return;
  }
  /* Slot × → clear */
  var clr = e.target.closest('[data-izy-clear]');
  if (clr) { IzyMix.clearSlot(parseInt(clr.getAttribute('data-izy-clear'), 10)); return; }
  /* Modal close (overlay or ×) */
  if (e.target.closest('[data-izy-modal-close]')) { IzyMix.closeModal(); return; }
  /* Modal "add set" CTA → close the builder, then add + open the cart drawer */
  var add = e.target.closest('[data-izy-modal-add]');
  if (add && !add.disabled) {
    var mixItems = IzyMix.getItems();
    IzyMix.closeModal();
    izyDoAdd(mixItems, add);
    return;
  }
});

/* Esc closes the modal */
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && IzyMix.state().modalOpen) IzyMix.closeModal();
});

document.addEventListener('DOMContentLoaded', function () { IzyMix.init(); });
if (document.readyState !== 'loading') IzyMix.init();

/* -- IZY Buybox: shared add-to-cart (used by the page ATC and the modal CTA) -- */

function izyDoAdd(items, btn, onSuccess) {
  if (!items || !items.length) return;

  var origHTML = btn ? btn.innerHTML : '';
  if (btn) { btn.innerHTML = '<span style="opacity:.6">' + izyEsc(izyT('submitting')) + '</span>'; btn.disabled = true; }

  /* Open the cart drawer immediately (synchronous) so opening never depends on network timing. */
  var drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    try { drawer.open(); } catch (e) { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); }
  } else if (drawer) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: '/' })
  })
    .then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
    })
    .then(function (result) {
      if (!result.ok) {
        var errMsg = result.data.description || result.data.message || izyT('not_available');
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        IzyToast.show({ title: izyT('not_in_stock'), message: errMsg, type: 'error', duration: 4500 });
        return;
      }
      /* Fill the already-open drawer with the freshly rendered cart contents. */
      try {
        if (result.data && result.data.sections && result.data.sections['cart-drawer'] && drawer && typeof drawer.updateFromCartChange === 'function') {
          drawer.updateFromCartChange(result.data.sections['cart-drawer']);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
      } catch (e) { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); }
      /* Safety: re-open if the content swap collapsed it. */
      try { if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) drawer.open(); } catch (e) {}
      var cartForm = document.querySelector('cart-form');
      if (cartForm && cartForm.refresh) cartForm.refresh();
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      if (typeof onSuccess === 'function') onSuccess();
    })
    .catch(function () {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      IzyToast.show({ title: izyT('error'), message: izyT('try_again'), type: 'error' });
    })
    .finally(function () {
      if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
    });
}

document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.classList || !form.classList.contains('izy-bb__form')) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var btn = form.querySelector('.izy-bb__atc');
  if (!btn || btn.disabled) return;

  /* On a mix page, tier 2/3: add the set when every slot is filled, otherwise open the
     picker to choose the remaining design(s). Tier 1 falls through and adds the single product. */
  if (document.querySelector('.izy-bb__mixwrap') && IzyMix.tierVal() > 1) {
    if (IzyMix.isComplete()) {
      izyDoAdd(IzyMix.getItems(), btn);
    } else {
      IzyMix.openModal();
    }
    return;
  }

  var items;
  if (document.querySelector('.izy-bb__mixwrap')) {
    items = IzyMix.getItems();
  } else {
    var variantId = form.querySelector('input[name="id"]').value;
    items = [{ id: parseInt(variantId, 10), quantity: 1 }];
  }
  if (!items.length) return;

  /* Stock check only for a single base product. */
  var stock = izyGetCurrentStock();
  if (items.length === 1 && stock > 0 && stock <= 20 && items[0].quantity > stock) {
    IzyToast.show({ title: izyT('not_enough_stock'), message: izyT('only_x_left', {n: stock}), type: 'error', duration: 4500 });
    return;
  }

  izyDoAdd(items, btn);
});

/* -- Also intercept sticky-atc form → add + open the cart drawer -- */

document.addEventListener('submit', function (e) {
  var form = e.target.closest('sticky-atc form');
  if (!form) return;

  e.preventDefault();
  e.stopPropagation();

  var variantId = form.querySelector('input[name="id"]').value;
  var btn = form.querySelector('button[type="submit"]');
  if (!btn || btn.disabled) return;

  btn.disabled = true;

  var drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    try { drawer.open(); } catch (e) { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); }
  } else if (drawer) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ quantity: 1, id: parseInt(variantId, 10), sections: ['cart-drawer'], sections_url: '/' })
  })
    .then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    })
    .then(function (result) {
      if (!result.ok) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        IzyToast.show({ title: izyT('not_in_stock'), message: izyT('sold_out'), type: 'error' });
        return;
      }
      try {
        if (result.data && result.data.sections && result.data.sections['cart-drawer'] && drawer && typeof drawer.updateFromCartChange === 'function') {
          drawer.updateFromCartChange(result.data.sections['cart-drawer']);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
      } catch (e) { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); }
      try { if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) drawer.open(); } catch (e) {}
      var cartForm = document.querySelector('cart-form');
      if (cartForm && cartForm.refresh) cartForm.refresh();
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    })
    .catch(function () {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      IzyToast.show({ title: izyT('error'), message: izyT('try_again'), type: 'error' });
    })
    .finally(function () {
      btn.disabled = false;
    });
});

/* -- Gallery carousel: Hears-style arrow + dots -- */

(function () {
  var built = false;

  function buildCarousel() {
    if (built) return;

    /* Skip on mobile -- a dedicated mobile handler takes over */
    if (window.innerWidth < 768 && !document.querySelector('.izy-npl-form')) return;

    var isNpl = !!document.querySelector('.izy-npl-form');
    var gallery;
    if (isNpl) {
      gallery = document.querySelector(
        '.section-new-main-product .product-column-left media-gallery'
      );
    } else {
      gallery = document.querySelector(
        '.section-new-main-product .detail.product-column-right media-gallery.desktop-only'
      );
    }
    if (!gallery) return;

    var mainImage = gallery.querySelector('.main-image');
    if (!mainImage) return;

    /* Collect visible slides */
    var allSlides = Array.prototype.slice.call(gallery.querySelectorAll('.slider__item'));
    var slides = allSlides.filter(function (s) { return !s.classList.contains('hidden'); });
    if (slides.length < 1) return;

    built = true;

    /* Use server-side is-active (variant's featured media) as the starting slide */
    var currentIndex = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) { currentIndex = i; break; }
    }

    var dots = [];

    function goTo(n) {
      if (n >= slides.length) n = 0;
      if (n < 0) n = slides.length - 1;
      currentIndex = n;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === currentIndex); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === currentIndex); });
    }

    /* Ensure the first slide is visible right away */
    goTo(currentIndex);

    /* Listen for variant changes from the buybox and jump to the correct image */
    gallery.addEventListener('izy:goto-media', function (e) {
      if (!e.detail || !e.detail.mediaId) return;
      var targetId = String(e.detail.mediaId);
      var allSlides = Array.prototype.slice.call(gallery.querySelectorAll('.slider__item'));
      for (var j = 0; j < allSlides.length; j++) {
        if (allSlides[j].getAttribute('data-media-id') === targetId) {
          /* Unhide if hidden (e.g. variant image hidden by Liquid logic) */
          allSlides[j].classList.remove('hidden');
          /* Update active state on all slides */
          allSlides.forEach(function (s) { s.classList.remove('is-active'); });
          allSlides[j].classList.add('is-active');
          /* Sync currentIndex if slide is in our array */
          for (var k = 0; k < slides.length; k++) {
            if (slides[k] === allSlides[j]) { currentIndex = k; break; }
          }
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === currentIndex); });
          return;
        }
      }
    });

    if (slides.length < 2) return;

    /* Click left half = prev, right half = next.
       Use capture phase so we intercept before the zoom <a> fires. */
    mainImage.addEventListener('click', function (e) {
      var item = e.target.closest('.slider__item');
      if (!item) return;
      /* Mobile: a tap should OPEN the zoom lightbox, not navigate. Let the event
         bubble through to the active slide's .show-gallery anchor (MediaGallery opens
         the pinch-zoomable viewer). Mobile navigation stays on the dots + next button. */
      if (window.matchMedia('(max-width: 767px)').matches) {
        if (item.querySelector('a.show-gallery')) return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      var rect = item.getBoundingClientRect();
      if (e.clientX >= rect.left + rect.width / 2) {
        goTo(currentIndex + 1);
      } else {
        goTo(currentIndex - 1);
      }
    }, true);

    /* Custom circle cursor with < / > arrow that follows the mouse */
    var cursor = document.createElement('div');
    cursor.className = 'izy-gallery-cursor';
    cursor.innerHTML =
      '<svg class="izy-gallery-cursor__icon" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="15 18 9 12 15 6"/></svg>';
    document.body.appendChild(cursor);

    mainImage.addEventListener('mousemove', function (e) {
      var item = e.target.closest('.slider__item');
      if (!item) {
        cursor.classList.remove('izy-gallery-cursor--visible');
        mainImage.style.cursor = '';
        return;
      }
      var rect = item.getBoundingClientRect();
      var isRight = e.clientX >= rect.left + rect.width / 2;
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
      /* Flip the chevron: points left by default, rotate 180deg for right */
      cursor.querySelector('.izy-gallery-cursor__icon').style.transform =
        isRight ? 'rotate(180deg)' : '';
      cursor.classList.add('izy-gallery-cursor--visible');
      mainImage.style.cursor = 'none';
    });
    mainImage.addEventListener('mouseleave', function () {
      cursor.classList.remove('izy-gallery-cursor--visible');
      mainImage.style.cursor = '';
    });

    /* Inject our next button directly into main-image.
       CSS sets main-image { position: relative } so the button
       anchors at bottom-right of the image area. */
    var nextBtn = document.createElement('button');
    nextBtn.className = 'izy-gallery-next';
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Volgende afbeelding');
    nextBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2.5" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="9 18 15 12 9 6"/></svg>';
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(currentIndex + 1);
    });
    mainImage.appendChild(nextBtn);

    /* Dots -- appended to media-gallery__inner, below the image */
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'izy-gallery-dots';
    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'izy-gallery-dot' + (i === currentIndex ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Afbeelding ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });
    var inner = gallery.querySelector('.media-gallery__inner');
    if (inner) inner.appendChild(dotsWrap);
  }

  function tryBuild() {
    buildCarousel();
    if (!built) {
      setTimeout(buildCarousel, 400);
      setTimeout(buildCarousel, 1200);
      setTimeout(buildCarousel, 3000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(tryBuild, 100); });
  } else {
    setTimeout(tryBuild, 100);
  }
})();

/* ------ NPL: sync variant selection to left-column carousel ------
   When city/color variant is selected, jump carousel to that variant's image. */
(function () {
  function initNplVariantSync() {
    if (!document.querySelector('.izy-npl-form')) return;

    var section = document.querySelector('.section-new-main-product');
    if (!section) return;

    var gallery = section.querySelector('.product-column-left media-gallery');
    if (!gallery) return;

    section.addEventListener('on:variant:change', function (e) {
      if (!e.detail || !e.detail.variant || !e.detail.variant.featured_media) return;
      var mediaId = String(e.detail.variant.featured_media.id);

      /* Dispatch izy:goto-media which the carousel listens to */
      gallery.dispatchEvent(new CustomEvent('izy:goto-media', {
        detail: { mediaId: mediaId }
      }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initNplVariantSync, 300); });
  } else {
    setTimeout(initNplVariantSync, 300);
  }
})();

/* -- Loox: move star rating into buybox, hide everything else -- */
(function () {
  function relocateLooxRating() {
    var ratingSlot = document.querySelector('.izy-bb__rating');
    if (!ratingSlot) return false;

    /* Find Loox rating widget (small stars + count) -- NOT the full reviews */
    var looxRating = document.querySelector('.loox-rating:not(.izy-bb__rating .loox-rating)');
    if (!looxRating) {
      /* Try data attribute selector */
      var candidates = document.querySelectorAll('[data-loox-id]');
      for (var i = 0; i < candidates.length; i++) {
        if (!ratingSlot.contains(candidates[i])) {
          looxRating = candidates[i];
          break;
        }
      }
    }
    if (!looxRating) return false;

    /* Move into the buybox rating slot */
    ratingSlot.appendChild(looxRating);
    return true;
  }

  /* Loox loads async -- keep trying */
  var attempts = 0;
  var timer = setInterval(function () {
    if (relocateLooxRating() || ++attempts > 20) clearInterval(timer);
  }, 500);
})();

/* -- Tab slider: resume autoplay 10s after user interaction --
   Autoplay itself is configured in main.js slick init.
   This adds: resume if user pauses by clicking/touching. */
(function () {
  var RESUME_AFTER = 10000;
  var resumeTimers = new WeakMap();

  function scheduleResume(el) {
    if (typeof jQuery === 'undefined' || !window.$) return;
    var existing = resumeTimers.get(el);
    if (existing) clearTimeout(existing);
    var t = setTimeout(function () {
      try { $(el).slick('slickPlay'); } catch (e) {}
    }, RESUME_AFTER);
    resumeTimers.set(el, t);
  }

  function init() {
    var sliders = document.querySelectorAll('.section-tab-slider .tab-slider.slick-initialized');
    if (!sliders.length) {
      setTimeout(init, 500);
      return;
    }
    sliders.forEach(function (el) {
      if (el.hasAttribute('data-izy-resume')) return;
      el.setAttribute('data-izy-resume', '1');
      ['click', 'touchstart'].forEach(function (evt) {
        el.addEventListener(evt, function () {
          scheduleResume(el);
        }, { passive: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 1200); });
  } else {
    setTimeout(init, 1200);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.section-tab-slider .tab-item, .section-tab-slider [data-trigger]')) {
      setTimeout(init, 700);
    }
  });
})();

/* -- IZY Mobile Gallery: clean single-image carousel -- */
(function () {
  function init() {
    var gallery = document.querySelector('.izy-mobile-gallery');
    if (!gallery) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.izy-mobile-gallery__slide'));
    if (!slides.length) return;

    var dotsWrap = gallery.querySelector('.izy-mobile-gallery__dots');
    var nextBtn = gallery.querySelector('.izy-mobile-gallery__next');
    var current = 0;
    var dots = [];
    var thumbs = [];

    function show(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      current = i;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === current);
      });
      var activeThumb = thumbs[current];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      }
    }

    /* Build small thumbnail strip under the main mobile image */
    if (slides.length > 1 && !(gallery.parentNode && gallery.parentNode.querySelector('.izy-mobile-thumbs'))) {
      var strip = document.createElement('div');
      strip.className = 'izy-mobile-thumbs';
      slides.forEach(function (s, idx) {
        var src = '';
        var simg = s.querySelector('img');
        if (simg) { src = simg.getAttribute('src') || simg.currentSrc || ''; }
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'izy-mobile-thumbs__item' + (idx === 0 ? ' is-active' : '');
        var ti = document.createElement('img');
        ti.src = src;
        ti.alt = '';
        ti.loading = 'lazy';
        t.appendChild(ti);
        t.addEventListener('click', function (e) { e.stopPropagation(); show(idx); });
        strip.appendChild(t);
        thumbs.push(t);
      });
      gallery.parentNode.insertBefore(strip, gallery.nextSibling);
    }

    /* Build dots */
    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, idx) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'izy-mobile-gallery__dot' + (idx === 0 ? ' is-active' : '');
        d.addEventListener('click', function (e) {
          e.stopPropagation();
          show(idx);
        });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    /* Next button */
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        show(current + 1);
      });
    }

    /* ---- Tap an image → open a full-screen, pinch-zoomable viewer ----
       Navigation on mobile stays on the dots / next button / thumbnail strip. */
    function hiRes(src) {
      if (!src) return src;
      if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$11600');
      return src;
    }
    function slideSrc(i) {
      var im = slides[i] && slides[i].querySelector('img');
      return im ? (im.currentSrc || im.getAttribute('src') || '') : '';
    }

    var zoom = null;
    function buildZoom() {
      var ov = document.createElement('div');
      ov.className = 'izy-zoom';
      ov.innerHTML =
        '<div class="izy-zoom__panel">' +
        '<button type="button" class="izy-zoom__close" aria-label="Sluiten">&times;</button>' +
        '<div class="izy-zoom__stage"><img class="izy-zoom__img" alt=""></div>' +
        '</div>';
      document.body.appendChild(ov);
      var stage = ov.querySelector('.izy-zoom__stage');
      var img = ov.querySelector('.izy-zoom__img');
      var scale = 1, tx = 0, ty = 0, idx = 0;
      var MAXS = 4;

      function apply() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
      function clamp() {
        var maxX = Math.max(0, (img.clientWidth * scale - stage.clientWidth) / 2);
        var maxY = Math.max(0, (img.clientHeight * scale - stage.clientHeight) / 2);
        tx = Math.min(maxX, Math.max(-maxX, tx));
        ty = Math.min(maxY, Math.max(-maxY, ty));
      }
      function reset() { scale = 1; tx = 0; ty = 0; apply(); }
      function setScaleAt(ns, sx, sy) {
        ns = Math.min(MAXS, Math.max(1, ns));
        var r = stage.getBoundingClientRect();
        var fX = (sx - r.left) - r.width / 2;
        var fY = (sy - r.top) - r.height / 2;
        tx = fX - (ns / scale) * (fX - tx);
        ty = fY - (ns / scale) * (fY - ty);
        scale = ns;
        clamp(); apply();
      }
      function open(i) {
        idx = i;
        img.src = hiRes(slideSrc(i));
        reset();
        document.documentElement.classList.add('izy-zoom-open');
        ov.classList.add('is-open');
      }
      function close() {
        ov.classList.remove('is-open');
        document.documentElement.classList.remove('izy-zoom-open');
      }

      function dist(a, b) { var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY; return Math.sqrt(dx * dx + dy * dy); }
      var startDist = 0, startScale = 1, panX = 0, panY = 0, startX = 0, startY = 0, moved = false, lastTap = 0;

      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) {
          panX = startX = e.touches[0].clientX; panY = startY = e.touches[0].clientY; moved = false;
        } else if (e.touches.length === 2) {
          startDist = dist(e.touches[0], e.touches[1]); startScale = scale; moved = true;
        }
      }, { passive: false });

      stage.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2) {
          e.preventDefault();
          if (startDist > 0) {
            var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            setScaleAt(startScale * (dist(e.touches[0], e.touches[1]) / startDist), mx, my);
          }
          moved = true;
        } else if (e.touches.length === 1) {
          var t = e.touches[0];
          if (Math.abs(t.clientX - startX) > 8 || Math.abs(t.clientY - startY) > 8) moved = true;
          if (scale > 1) {
            e.preventDefault();
            tx += t.clientX - panX; ty += t.clientY - panY; clamp(); apply();
          }
          panX = t.clientX; panY = t.clientY;
        }
      }, { passive: false });

      stage.addEventListener('touchend', function (e) {
        if (e.touches.length > 0) return;
        var t = e.changedTouches && e.changedTouches[0];
        if (!moved && t) {
          /* double-tap toggles zoom */
          var now = Date.now();
          if (now - lastTap < 300) { if (scale > 1) reset(); else setScaleAt(2.5, t.clientX, t.clientY); lastTap = 0; }
          else { lastTap = now; }
          return;
        }
        if (scale <= 1 && t) {
          var dx = t.clientX - startX, dy = t.clientY - startY;
          if (Math.abs(dy) > Math.abs(dx) && dy > 80) { close(); return; }
          if (Math.abs(dx) > 50 && slides.length > 1) {
            idx = dx < 0 ? (idx + 1) % slides.length : (idx - 1 + slides.length) % slides.length;
            img.src = hiRes(slideSrc(idx)); reset(); show(idx);
          }
        }
      }, { passive: false });

      ov.querySelector('.izy-zoom__close').addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); }); /* tap dim backdrop to close */
      window.addEventListener('resize', function () { if (ov.classList.contains('is-open')) { clamp(); apply(); } });
      return { open: open, close: close };
    }

    /* Swipe the main image left/right to change slides (a plain tap still opens the zoom viewer) */
    var swStartX = 0, swStartY = 0, swiping = false, swiped = false;
    gallery.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) { swiping = false; return; }
      swStartX = e.touches[0].clientX; swStartY = e.touches[0].clientY; swiping = true; swiped = false;
    }, { passive: true });
    gallery.addEventListener('touchmove', function (e) {
      if (!swiping || !e.touches || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - swStartX, dy = e.touches[0].clientY - swStartY;
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) swiped = true;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      if (!swiped) return;
      var t = e.changedTouches && e.changedTouches[0];
      if (t && slides.length > 1) {
        var dx = t.clientX - swStartX;
        if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    /* Tap the main image → open the zoom viewer (ignore right after a swipe) */
    gallery.addEventListener('click', function (e) {
      if (swiped) { swiped = false; return; }
      if (e.target.closest('.izy-mobile-gallery__next, .izy-mobile-gallery__dot')) return;
      if (!zoom) zoom = buildZoom();
      zoom.open(current);
    });

    /* Variant change: jump to matching media */
    document.addEventListener('on:variant:change', function (e) {
      if (!e.detail || !e.detail.variant || !e.detail.variant.featured_media) return;
      var targetId = String(e.detail.variant.featured_media.id);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === targetId) {
          show(i);
          return;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* -- Image strip: click to jump gallery to that image -- */
(function () {
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.izy-image-strip__item');
    if (!item) return;
    var mediaId = item.getAttribute('data-media-id');
    if (!mediaId) return;

    var gallery = document.querySelector(
      '.section-new-main-product .detail.product-column-right media-gallery.desktop-only'
    ) || document.querySelector(
      '.section-new-main-product .product-column-left media-gallery'
    );
    if (gallery) {
      gallery.dispatchEvent(new CustomEvent('izy:goto-media', {
        detail: { mediaId: String(mediaId) }
      }));
    }

    /* Scroll to gallery */
    var galleryEl = document.querySelector('.section-new-main-product .main-image');
    if (galleryEl) {
      galleryEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* Highlight active strip item */
    document.querySelectorAll('.izy-image-strip__item').forEach(function (el) {
      el.classList.remove('is-active');
    });
    item.classList.add('is-active');
  });
})();

/* -- Loox iframe style injection -- */

(function () {
  var looxCSS = [
    /* Hide reviews with 1-3 stars (aria-label based) */
    '.grid-item-wrap:has(.stars [aria-label*="1 /"]) { display: none !important; }',
    '.grid-item-wrap:has(.stars [aria-label*="2 /"]) { display: none !important; }',
    '.grid-item-wrap:has(.stars [aria-label*="3 /"]) { display: none !important; }',
    /* Clean card styling */
    '.grid-item { border-radius: 12px !important; border: 1px solid #eee !important; box-shadow: none !important; }',
    '.grid-item:hover { background: #fafafa !important; }',
    /* Cleaner text */
    '.main-text { font-size: 14px !important; line-height: 1.55 !important; color: #333 !important; }',
    '.title { font-weight: 600 !important; font-size: 14px !important; }',
    /* Product box at bottom */
    '.product-box { border-top: 1px solid #f0f0f0 !important; margin-top: 12px !important; padding-top: 12px !important; }',
    '.product-box img { border-radius: 6px !important; }',
    '.product-box .name { font-size: 13px !important; }'
  ].join('\n');

  function injectIntoLooxIframe() {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      try {
        var doc = iframes[i].contentDocument || iframes[i].contentWindow.document;
        if (!doc) continue;
        var grid = doc.querySelector('#grid');
        if (!grid) continue;
        if (doc.getElementById('izy-loox-styles')) continue;
        var style = doc.createElement('style');
        style.id = 'izy-loox-styles';
        style.textContent = looxCSS;
        doc.head.appendChild(style);
      } catch (e) {
        /* cross-origin iframe, skip */
      }
    }
  }

  /* Loox loads async, retry a few times */
  var attempts = 0;
  var timer = setInterval(function () {
    injectIntoLooxIframe();
    attempts++;
    if (attempts > 20) clearInterval(timer);
  }, 1500);
})();

/* -- IZY Buybox: helpers -- */

/* The presentment currency shown to the visitor. Markets with local currencies (e.g. the
   International market) convert prices to the buyer's currency — so read the live currency
   from the buybox (Liquid-injected) or Shopify's global, and format accordingly. */
function izyActiveCurrency() {
  var w = document.querySelector('.izy-bb__mixwrap');
  var c = w && w.getAttribute('data-currency');
  if (c) return c;
  if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
  return 'EUR';
}
function izyFormatPrice(cents) {
  var cur = izyActiveCurrency();
  var locale = (document.documentElement.lang || 'nl').replace('_', '-');
  try {
    return (cents / 100).toLocaleString(locale, { style: 'currency', currency: cur });
  } catch (e) {
    return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
  }
}

function izyGetVariants() {
  var el = document.querySelector('.izy-variant-data');
  if (!el) return [];
  try { return JSON.parse(el.textContent); } catch (e) { return []; }
}

function izyGetCurrentStock() {
  var idInput = document.querySelector('.izy-bb__form input[name="id"]');
  if (!idInput) return 999;
  var variantId = parseInt(idInput.value, 10);
  var variants = izyGetVariants();
  var match = variants.find(function (v) { return v.id === variantId; });
  if (!match) return 999;
  /* If inventory_policy is 'continue', allow unlimited */
  if (match.inventory_policy === 'continue') return 999;
  return match.inventory_quantity || 0;
}

/* Tier selection, slot picking, and ATC pricing are owned by the IzyMix module above. */

/* -- Variant pill click -- */

document.addEventListener('click', function (e) {
  var pill = e.target.closest('.izy-bb__pill');
  if (!pill) return;

  var group = pill.closest('.izy-bb__pills');
  if (!group) return;

  // Toggle active
  group.querySelectorAll('.izy-bb__pill').forEach(function (p) {
    p.classList.remove('is-active');
  });
  pill.classList.add('is-active');

  // Update label
  var optGroup = pill.closest('.izy-bb__option');
  if (optGroup) {
    var sel = optGroup.querySelector('[data-izy-selected]');
    if (sel) sel.textContent = pill.getAttribute('data-val');
  }

  // Collect selected options
  var selected = [];
  document.querySelectorAll('.izy-bb__pills').forEach(function (g) {
    var active = g.querySelector('.izy-bb__pill.is-active');
    if (active) selected.push(active.getAttribute('data-val'));
  });

  // Find variant match
  var variants = izyGetVariants();
  var match = variants.find(function (v) {
    return v.options.every(function (opt, i) {
      return !selected[i] || opt === selected[i];
    });
  });

  if (!match) return;

  // Update form
  var idInput = document.querySelector('.izy-bb__form input[name="id"]');
  if (idInput) idInput.value = match.id;

  // Reset the Mix & Match selector to tier 1 with the newly-selected base variant
  if (typeof IzyMix !== 'undefined' && document.querySelector('.izy-bb__mixwrap')) {
    IzyMix.setTier(1);
    IzyMix.setBasePrice(match.price, match.id);
  }

  // Update URL
  var url = new URL(window.location);
  url.searchParams.set('variant', match.id);
  window.history.replaceState({}, '', url);

  // Switch gallery to this variant's image
  if (match.featured_media_id) {
    var gallery = document.querySelector(
      '.section-new-main-product .detail.product-column-right media-gallery.desktop-only'
    );
    if (gallery) {
      gallery.dispatchEvent(new CustomEvent('izy:goto-media', {
        detail: { mediaId: String(match.featured_media_id) }
      }));
    }
  }
});

/* ── IZY sticky add-to-cart (robust; clicks the real buybox ATC) ───────── */
(function () {
  var mainBtn = document.querySelector('.izy-bb__atc')
    || document.querySelector('.section-new-main-product .product-form [name="add"]');
  if (!mainBtn) return;
  if (document.querySelector('.izy-sticky-atc')) return;

  var titleEl = document.querySelector('.section-new-main-product .product-title');
  var title = document.title || '';
  if (titleEl) {
    var titleClone = titleEl.cloneNode(true);
    var smallTitle = titleClone.querySelector('.small-title');
    if (smallTitle) smallTitle.remove();
    title = titleClone.textContent.trim();
  }
  var imgEl = document.querySelector(
    '.media-gallery.desktop-only .slider__item.is-active .product-media img,'
    + '.izy-image-strip__item img,'
    + '.izy-mobile-gallery__slide img,'
    + '.product-media--image img'
  );
  var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

  var bar = document.createElement('div');
  bar.className = 'izy-sticky-atc';
  bar.innerHTML =
    '<div class="izy-sticky-atc__info">'
    + (imgSrc ? '<span class="izy-sticky-atc__thumb"><img src="' + imgSrc + '" alt=""></span>' : '')
    + '<span class="izy-sticky-atc__title"></span>'
    + '<span class="izy-sticky-atc__qty" aria-live="polite" aria-label="Aantal geselecteerd">1</span>'
    + '</div>'
    + '<button type="button" class="izy-sticky-atc__btn" aria-label="In winkelwagen"></button>';
  document.body.appendChild(bar);
  bar.querySelector('.izy-sticky-atc__title').textContent = title;

  var stickyBtn = bar.querySelector('.izy-sticky-atc__btn');

  function syncLabel() {
    var html = mainBtn.innerHTML;
    stickyBtn.innerHTML = (html && html.trim()) ? html : 'In winkelwagen';
    stickyBtn.disabled = !!mainBtn.disabled;
  }
  syncLabel();
  try {
    new MutationObserver(syncLabel).observe(mainBtn, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']
    });
  } catch (e) {}

  /* Read-only quantity = how many designs are currently selected in the buy box above. */
  var qtyEl = bar.querySelector('.izy-sticky-atc__qty');
  function updateStickyQty() {
    if (!qtyEl) return;
    var n = (window.IzyMix && IzyMix.filledCount && IzyMix.filledCount()) || 1;
    qtyEl.textContent = n;
  }
  updateStickyQty();
  document.addEventListener('izy:mix:change', updateStickyQty);

  stickyBtn.addEventListener('click', function () {
    if (mainBtn.disabled) return;
    mainBtn.click();
  });

  var shown = false;
  function setShown(v) { if (v !== shown) { shown = v; bar.classList.toggle('is-visible', v); } }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      setShown(!entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 }).observe(mainBtn);
  } else {
    window.addEventListener('scroll', function () {
      var r = mainBtn.getBoundingClientRect();
      setShown(r.bottom < 0 || r.top > window.innerHeight);
    }, { passive: true });
  }
})();

/* -- Cart cross-sell: let vertical mouse-wheel scroll the drawer instead of being
   swallowed as horizontal scroll by the "Ook de moeite waard" carousel -- */
(function () {
  document.addEventListener('wheel', function (e) {
    var slider = e.target.closest ? e.target.closest('.cart-item-upsells .slider') : null;
    if (!slider) return;
    // only redirect when the gesture is mostly vertical
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    var scroller = slider.closest('.cart-drawer__content');
    if (!scroller) return;
    scroller.scrollTop += e.deltaY;
    e.preventDefault();
  }, { passive: false });
})();
/* -- PDP hero badges overlay: 4 trust/USP chips on the product main photo -- */
(function () {
  if (!document.querySelector('.section-new-main-product')) return;
  var L = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var T = {
    trial:     { nl: '30 dagen gratis proberen', en: 'Try free for 30 days', de: '30 Tage gratis testen', fr: 'Essai gratuit 30 jours', es: 'Prueba 30 días gratis', it: 'Provalo 30 giorni gratis', da: 'Prøv gratis i 30 dage', ja: '30日間無料でお試し', pt: 'Experimente grátis 30 dias' },
    warranty:  { nl: '1 jaar garantie', en: '1-year warranty', de: '1 Jahr Garantie', fr: 'Garantie 1 an', es: '1 año de garantía', it: '1 anno di garanzia', da: '1 års garanti', ja: '1年保証', pt: '1 ano de garantia' },
    official:  { nl: 'Officiële collectie', en: 'Official collection', de: 'Offizielle Kollektion', fr: 'Collection officielle', es: 'Colección oficial', it: 'Collezione ufficiale', da: 'Officiel kollektion', ja: '公式コレクション', pt: 'Coleção oficial' },
    dishwasher:{ nl: 'Vaatwasmachinebestendig', en: 'Dishwasher safe', de: 'Spülmaschinenfest', fr: 'Va au lave-vaisselle', es: 'Apto para lavavajillas', it: 'Lavabile in lavastoviglie', da: 'Tåler opvaskemaskine', ja: '食洗機対応', pt: 'Adequado para máquina de lavar' }
  };
  function t(k) { return T[k][L] || T[k].en; }
  var IC = {
    trial:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    warranty:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    official:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="5"/><path d="M9 13.5L8 21l4-2 4 2-1-7.5"/></svg>',
    dishwasher: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c3 3 4 5 4 7a4 4 0 0 1-8 0c0-2 1-4 4-7z"/></svg>'
  };
  function chip(key, hl) { return '<span class="izy-badge' + (hl ? ' izy-badge--hl' : '') + '">' + IC[key] + '<span>' + t(key) + '</span></span>'; }
  var official = (typeof window.izyOfficialCollection !== 'undefined') ? !!window.izyOfficialCollection : false;
  var HTML =
    '<div class="izy-hero-badges" aria-hidden="true">' +
      '<div class="izy-hero-badges__top">' + chip('trial', true) + chip('warranty') + '</div>' +
      '<div class="izy-hero-badges__bottom">' + (official ? chip('official') : '') + chip('dishwasher') + '</div>' +
    '</div>';
  function inject() {
    var targets = [];
    var mob = document.querySelector('.izy-mobile-gallery');
    if (mob) targets.push(mob);
    document.querySelectorAll('.section-new-main-product media-gallery .main-image').forEach(function (m) { targets.push(m); });
    targets.forEach(function (el) {
      if (el.querySelector(':scope > .izy-hero-badges')) return;
      el.insertAdjacentHTML('beforeend', HTML);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
  setTimeout(inject, 600); setTimeout(inject, 1500);
})();


/* -- Homepage hero: on MOBILE move the ★★★★★ "Excellent" rating below the buttons. -- */
(function () {
  var rating = document.querySelector('.text-overlay--for-banner .promo-rating');
  if (!rating) return;
  var overlay = rating.closest('.text-overlay__text');
  if (!overlay) return;
  var home = document.createComment('izy-hero-rating-home');
  rating.parentNode.insertBefore(home, rating);
  var mq = window.matchMedia('(max-width: 767px)');
  function place() {
    var btns = overlay.querySelector('.text-overlay__button-row');
    if (mq.matches && btns) {
      if (btns.nextElementSibling !== rating) { btns.insertAdjacentElement('afterend', rating); rating.classList.add('izy-rating--moved'); }
    } else if (home.parentNode && home.nextSibling !== rating) {
      home.parentNode.insertBefore(rating, home.nextSibling); rating.classList.remove('izy-rating--moved');
    }
  }
  place();
  if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  setTimeout(place, 800); setTimeout(place, 1800);
})();

/* -- Back-in-stock (sold-out PDP) → Klaviyo Back in Stock (public site id TaW2h5) -- */
(function () {
  var KLAVIYO_ID = 'TaW2h5';
  function bisVariant(bis) {
    var form = document.querySelector('.izy-bb__form');
    var idInput = form && form.querySelector('input[name="id"]');
    return (idInput && idInput.value) || bis.getAttribute('data-variant') || '';
  }
  function msg(bis, form, text, ok) {
    var el = form.querySelector('[data-izy-bis-msg]');
    if (!el) return;
    el.hidden = false; el.textContent = text;
    el.classList.toggle('izy-bis__msg--ok', !!ok);
    el.classList.toggle('izy-bis__msg--err', !ok);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-izy-bis-toggle]');
    if (!t) return;
    var bis = t.closest('[data-izy-bis]'); if (!bis) return;
    var form = bis.querySelector('[data-izy-bis-form]');
    if (form) { form.hidden = false; t.style.display = 'none'; var em = form.querySelector('[data-izy-bis-email]'); if (em) em.focus(); }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-izy-bis-form]');
    if (!form) return;
    e.preventDefault();
    var bis = form.closest('[data-izy-bis]'); if (!bis) return;
    var emailEl = form.querySelector('[data-izy-bis-email]');
    var email = (emailEl && emailEl.value || '').trim();
    var variant = bisVariant(bis);
    if (!email || email.indexOf('@') < 1) { msg(bis, form, bis.getAttribute('data-bis-invalid') || 'Invalid email', false); return; }
    if (!variant) { msg(bis, form, bis.getAttribute('data-bis-error') || 'Error', false); return; }
    var submitBtn = form.querySelector('.izy-bis__submit'); if (submitBtn) submitBtn.disabled = true;
    /* Klaviyo Client back-in-stock API (the old /onsite/components endpoint was retired -> HTTP 410).
       Variant id uses Klaviyo's Shopify catalog format: $shopify:::$default:::<variantId>. */
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_ID), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
          }
        }
      })
    }).then(function (r) {
      if (r.ok) {
        form.querySelector('.izy-bis__row').style.display = 'none';
        msg(bis, form, bis.getAttribute('data-bis-success') || 'Thanks!', true);
      } else {
        if (submitBtn) submitBtn.disabled = false;
        msg(bis, form, bis.getAttribute('data-bis-error') || 'Error', false);
      }
    }).catch(function () {
      if (submitBtn) submitBtn.disabled = false;
      msg(bis, form, bis.getAttribute('data-bis-error') || 'Error', false);
    });
  });
})();

/* Move sold-out product cards to the end of every collection grid. Re-runs whenever the grid
   changes (swatches / hover / "show more" can re-render blocks on desktop after first load).
   The needsSort() guard makes our own appendChild a no-op, so the observer can't loop. */
(function () {
  function directBlocks(grid) {
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.classList && el.classList.contains('product-block');
    });
  }
  function needsSort(grid) {
    var seenSold = false, blocks = directBlocks(grid);
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].classList.contains('product-block--sold-out')) seenSold = true;
      else if (seenSold) return true; /* an in-stock card sits after a sold-out one */
    }
    return false;
  }
  function sortGrid(grid) {
    if (!needsSort(grid)) return;
    var blocks = directBlocks(grid);
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].classList.contains('product-block--sold-out')) grid.appendChild(blocks[i]);
    }
  }
  function run() {
    document.querySelectorAll('.product-grid').forEach(function (grid) {
      sortGrid(grid);
      if (!grid.__izySoldObs && window.MutationObserver) {
        grid.__izySoldObs = new MutationObserver(function () { sortGrid(grid); });
        grid.__izySoldObs.observe(grid, { childList: true });
      }
    });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
